import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, setDoc, arrayUnion } from 'firebase/firestore';

const ReviewAction = ({ issueId, totalIssues = 5 }) => {
  // 현재 5호까지 있다고 가정
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nickname, setNickname] = useState('');
  const [reviewBody, setReviewBody] = useState('');
  // 기본값을 현재 보고 있는 호수로 설정
  const [selectedTarget, setSelectedTarget] = useState(`${issueId}호`);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 1. 1호부터 지금까지의 호수 리스트 생성
  const issueList = Array.from({ length: totalIssues }, (_, i) => `${i + 1}호`);
  // issueList.push('해당 없음 / 기타'); // 기타 옵션 추가

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reviewBody.trim()) return alert('후기 내용을 입력해주세요! 🍏');

    setIsSubmitting(true);
    try {
      // 선택한 호수의 문서에 저장되도록 설정
      const targetIssueNum = selectedTarget.replace(/[^0-9]/g, ''); // 숫자만 추출
      const docId = targetIssueNum ? `review_${targetIssueNum}` : `review_general`;

      const docRef = doc(db, 'reviews', docId);
      await setDoc(
        docRef,
        {
          reviews: arrayUnion({
            body: reviewBody,
            nickname: nickname || '익명',
            target: selectedTarget,
            date: new Date().toLocaleDateString('ko-KR'),
          }),
        },
        { merge: true },
      );

      alert('소중한 후기가 등록되었습니다. ✨');
      setIsModalOpen(false);
      setNickname('');
      setReviewBody('');
    } catch (error) {
      console.error('저장 실패:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <button className="go-review-btn" onClick={() => setIsModalOpen(true)}>
        후기 작성하러 가기
      </button>

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <header className="modal-header">
              <h3 className="modal-title">후기 작성하기</h3>
              <button className="modal-close-btn" onClick={() => setIsModalOpen(false)}>
                ✕
              </button>
              <p className="modal-description">지나간 호수의 글에 대해서도 자유롭게 남겨주세요.</p>
            </header>

            <div className="modal-form-area">
              <div className="form-row">
                <label className="form-label">후기</label>
                <textarea
                  className="form-input textarea"
                  placeholder="의견을 남겨주세요."
                  value={reviewBody}
                  onChange={(e) => setReviewBody(e.target.value)}
                />
              </div>
              <div className="form-row">
                <label className="form-label">작성자</label>
                <input
                  className="form-input"
                  placeholder="별명 (미입력 시 익명)"
                  value={nickname}
                  onChange={(e) => setNickname(e.target.value)}
                />
              </div>
              <div className="form-row">
                <label className="form-label">대상 호수</label>
                {/* 디자인의 토글 리스트 */}
                <select
                  className="modal-select"
                  value={selectedTarget}
                  onChange={(e) => setSelectedTarget(e.target.value)}
                >
                  {issueList.map((issue) => (
                    <option key={issue} value={issue}>
                      {issue}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <footer className="modal-footer">
              <button className="modal-btn cancel" onClick={() => setIsModalOpen(false)}>
                작성 취소
              </button>
              <button className="modal-btn submit" onClick={handleSubmit} disabled={isSubmitting}>
                {isSubmitting ? '등록 중...' : '작성 완료'}
              </button>
            </footer>
          </div>
        </div>
      )}
    </>
  );
};

export default ReviewAction;
